// src/components/common/Pagination/AppPagination.jsx

import React from "react";
import "../../../assets/css/general/pagination/Pagination.css";

const AppPagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  // ── Calculations ──
  const from = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const to   = Math.min(currentPage * itemsPerPage, totalItems);

  // ── Page Numbers Logic ──
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }
    return pages;
  };

  if (totalPages <= 0) return null;

  return (
    <div className="app-pagination-wrapper">
      {/* ── Showing Info ── */}
      <p className="app-pagination-info">
        Showing {from} to {to} of {totalItems} results
      </p>

      {/* ── Controls ── */}
      <div className="app-pagination-controls">

        {/* Prev Arrow */}
        <button
          className="app-pg-arrow"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ‹
        </button>

        {/* Page Numbers */}
        {getPageNumbers().map((page, idx) =>
          page === "..." ? (
            <span key={`dots-${idx}`} className="app-pg-dots">···</span>
          ) : (
            <button
              key={page}
              className={`app-pg-btn ${currentPage === page ? "app-pg-active" : ""}`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          )
        )}

        {/* Next Arrow */}
        <button
          className="app-pg-arrow"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          ›
        </button>

      </div>
    </div>
  );
};

export default AppPagination;